module.exports = __webpack_public_path__ + "static/media/pollu.a66d0eca.svg";